module.exports = __webpack_public_path__ + "img/sectReword_broght.75e1131e.png";